import { commonClientResx } from "../../../resxDist/commonClientResx";
import { createButton } from "../Button";
import { ButtonColorSchemes, ButtonFlag, ButtonVariants } from "../Enums";

/** 'Save' text by default. */
export const ButtonPositive = createButton("ButtonPositive", {
    colorScheme: ButtonColorSchemes.Positive,
    text: commonClientResx.Save,
});

//NOTE: in future we are going to replace old green and blue buttons with this button
export const ButtonAccent = createButton("ButtonAccent", {
    colorScheme: ButtonColorSchemes.Positive,
    flags: ButtonFlag.Small,
});

export const ButtonPrimaryInlineText = createButton("ButtonPrimaryInlineText", {
    variant: ButtonVariants.Inline,
    colorScheme: ButtonColorSchemes.Positive,
    flags: ButtonFlag.Small,
});
